import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Location } from '@angular/common';

import { AuthenticationService } from '~/core/services/authentication.service';
import { URLS } from '~/core/constants/constants';
import { isDesktop } from '~/core/helpers/device-utils';
export const signInGuard: CanActivateFn = (route, state) => {
  const authenticationService: AuthenticationService = inject(AuthenticationService);
  const router: Router = inject(Router);

  if (authenticationService.isLoggedIn()) {
    router.navigate(['/']);
    return false;
  }
  if (isDesktop()) {
    const location: Location = inject(Location);

    const queryParams = route.queryParams;

    if (Object.keys(queryParams).length > 0) {
      if (queryParams?.affiliate_id) {
        authenticationService.setAffiliated(JSON.stringify({ id: route.queryParams.affiliate_id }));
      }
      authenticationService.setExternalParams(route.queryParams);
    }

    const redirectTo = route.queryParams.redirectTo;
    let navigateTo = '';
    if (redirectTo) {
      navigateTo = redirectTo.includes(URLS.CASINO_LIVE) ? URLS.CASINO_LIVE : redirectTo.includes(URLS.CASINO) ? URLS.CASINO : '';
    }

    void router.navigate([navigateTo]).then(() => {
      const previousUrl = redirectTo || location.path() || '/';
      authenticationService.openSignInDialog(previousUrl);
      location.replaceState(state.url);
    });
    return false;
  } else {
    return true;
  }
};
